// Import all page schemas
import { catalogPageStateSchema } from './catalogPageStateSchema';
import { stowInventoryPageStateSchema } from './stowInventoryPageStateSchema';
import { userInventoryPageStateSchema } from './userInvenetoryPageStateSchema';
import userInventoryLocationsStateSchema from './userInventoryLocationsStateSchema';
import { batchesPageStateSchema } from './batchesPageStateSchema';
import { sourcesPageStateSchema } from './sourcesPageStateSchema';
import { buyLegoPageStateSchema } from './buyLegoPageStateSchema';
import userSettingsStateSchema from './userSettingsStateSchema';
import { redistributionPageStateSchema } from './redistributionPageStateSchema';
import { containerTypesPageStateSchema } from './containerTypesPageStateSchema';
import { ordersPageStateSchema } from './ordersPageStateSchema';
import { userSetsPageStateSchema } from './userSetsPageStateSchema';
import { inventoryAuditPageStateSchema } from './inventoryAuditPageStateSchema';

// Export individual schemas
export {
  catalogPageStateSchema,
  stowInventoryPageStateSchema,
  userInventoryPageStateSchema,
  userInventoryLocationsStateSchema,
  batchesPageStateSchema,
  sourcesPageStateSchema,
  buyLegoPageStateSchema,
  userSettingsStateSchema,
  redistributionPageStateSchema,
  containerTypesPageStateSchema,
  ordersPageStateSchema,
  userSetsPageStateSchema,
  inventoryAuditPageStateSchema
};

// Export combined schemas object for easy integration
export const pageSchemas = {
  catalog: catalogPageStateSchema,
  stowInventory: stowInventoryPageStateSchema,
  userInventory: userInventoryPageStateSchema,
  userInventoryLocations: userInventoryLocationsStateSchema,
  batches: batchesPageStateSchema,
  sources: sourcesPageStateSchema,
  buyLego: buyLegoPageStateSchema,
  userSettings: userSettingsStateSchema,
  redistribution: redistributionPageStateSchema,
  containerTypes: containerTypesPageStateSchema,
  orders: ordersPageStateSchema,
  userSets: userSetsPageStateSchema,
  inventoryAudit: inventoryAuditPageStateSchema
};